module.exports = __webpack_public_path__ + "static/media/schlemmer7.cf9d5bb6.jpg";